<script lang="ts" setup>
import { useObserversStore } from '@/store/observers/observers'

import HeaderBottomCategories from '@/components/Header/HeaderBottomCategories.vue'
import HeaderBottomLinks from '@/components/Header/HeaderBottomLinks.vue'

const { categoryListState } = storeToRefs(useObserversStore())
</script>

<template>
  <nav class="menu">
    <transition name="list">
      <header-bottom-categories v-if="categoryListState" />

      <header-bottom-links v-else />
    </transition>
  </nav>
</template>

<style lang="scss" scoped>
.menu {
  max-height: 34px;
  overflow: hidden;
  border-top: 1px solid var(--ui-grey);
  border-bottom: 1px solid var(--ui-grey);
}

.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease;
}

.list-enter {
  transform: translateY(-5px);
}

.list-leave-to {
  opacity: 0;
  transform: translateY(5px);
}
</style>
